import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import noScroll from 'no-scroll';
import { TriggerLabel } from './fullMobileOverlayStyles';

class OverlayTrigger extends PureComponent {
	freezeBody = () => {
		const { onClick } = this.props;
		noScroll.on();
		onClick && onClick();
	}

	render() {
		const { triggerId, children, ...passProps } = this.props;
		return (
			<TriggerLabel
				// Pass `className` along to allow `OverlayTrigger` to be re-styled downstream
				// i.e. const StyledOverlayTrigger = styled(OverlayTrigger)``;
				// https://styled-components.com/docs/advanced#caveat
				{...passProps}
				htmlFor={triggerId}
				onClick={this.freezeBody}>
				{children}
			</TriggerLabel>
		);
	}
}

OverlayTrigger.propTypes = {
	triggerId: PropTypes.string.isRequired,
	children: PropTypes.node,
	onClick: PropTypes.func,
	largeTrigger: PropTypes.bool,
};

OverlayTrigger.defaultProps = {
	largeTrigger: false,
};

export default OverlayTrigger;
